<template>
  <div>
    <tip-tap-output
      v-if="sessionAgenda"
      style="
      overflow-y: scroll;
      height:70vh;
      margin-top: 25px;
      margin-left: 25px;
      border-radius: 15px;
      background-color:rgba(126,102,155,0.51);
      padding:15px;
      color: whitesmoke;
      "
      :content="sessionAgenda"
      :use-dots="true"
    />
    <div v-else>
      <b-button pill variant="primary" @click="handleAddDataButtonClick">
        Add Agenda
      </b-button>
    </div>
  </div>
</template>

<script>
import TipTapOutput from "@/components/common/tipTapOutput";
export default {
  name: "Sessions_Agenda",
  components: {
    TipTapOutput
  },
  props: {
    session: {
      type: Object,
      default: () => {}
    },
    profile: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {},
  computed: {},
  methods: {
    handleAddDataButtonClick() {
      this.$emit("add-data-click");
    }
  },
  data() {
    return {
      sessionDescription:
        this.session && this.session.session && this.session.session.description
          ? this.session.session.description
          : "",
      sessionAgenda:
        this.session && this.session.session && this.session.session.agenda
          ? this.session.session.agenda
          : ""
    };
  }
};
</script>

<style lang="scss" scoped></style>
